import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import Axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { url } from "../../../../Config/Config";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import StudentForm from "./StudentForm/StudentForm";
import { useStyles } from "./StudentAttendance.css";
import ViewStudentAttendance from "./ViewStudentAttendance/ViewStudentAttendance";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class StudentAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        session: new Date().getFullYear(),
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
      studentList: [],
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let filteredList = [];
      const response = await Axios.get(`${url}/api/students`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.students.length !== 0) {
        filteredList = response.data.students.filter((student) => {
          return this.state.data.faculty === "" && this.state.data.group === ""
            ? student.currentSession.indexOf(this.state.data.session) !== -1 &&
                student.studentClass.indexOf(this.state.data.class) !== -1 &&
                student.section.indexOf(this.state.data.section) !== -1
            : student.currentSession.indexOf(this.state.data.session) !== -1 &&
                student.studentClass.indexOf(this.state.data.class) !== -1 &&
                student.faculty &&
                student.faculty.indexOf(this.state.data.faculty) !== -1 &&
                student.group &&
                student.group.indexOf(this.state.data.group) !== -1 &&
                student.section.indexOf(this.state.data.section) !== -1;
        });
      }
      let studentList = [];
      if (filteredList.length !== 0) {
        for (let i = 0; i <= filteredList.length - 1; i++) {
          studentList.push({
            studentId: filteredList[i]._id,
            studentName:
              filteredList[i].firstName + " " + filteredList[i].lastName,
            admissionId: filteredList[i].admissionId,
            status: "P",
            date: moment(new Date()).format("YYYY-MM-DD"),
          });
        }
        this.setState({
          studentList,
          isEmpty: false,
          loading: false,
        });
      } else {
        this.setState({
          studentList: [],
          isEmpty: true,
          loading: false,
        });
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Student Attendance"
            refreshUrl={this.props.match.url}
          />
          <StudentForm
            loading={this.state.loading}
            buttonLabel="Get Students"
            data={this.state.data}
            handleChangeClass={this.handleChangeClass}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          {this.state.studentList.length !== 0 ? (
            <ViewStudentAttendance
              config={this.state.data}
              studentList={this.state.studentList}
            />
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage description="No students are found in this class. Please add them to list" />
          ) : (
            <CustomEmptyMessage description="Please fill the above form" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(StudentAttendance)));
